import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n";
import { preloadRoute } from "./routes";
import { getLangFromPath, localizePath } from "./utils/seoConfig";

// Posetilac koji je ranije izabrao nemački dolazi na nemačku verziju iste stranice.
// Crawleri nemaju localStorage, pa za njih URL ostaje nepromenjen.
const redirectToPreferredLanguage = () => {
  try {
    const { pathname, search, hash } = window.location;
    const preferred = localStorage.getItem("i18nextLng");
    if (preferred && preferred.startsWith("de") && getLangFromPath(pathname) === "en") {
      window.history.replaceState(null, "", localizePath(pathname, "de") + search + hash);
      i18n.changeLanguage("de");
    }
  } catch (e) {
    // localStorage nije dostupan (privatni režim i sl.)
  }
};

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

redirectToPreferredLanguage();
preloadRoute(window.location.pathname).then(renderApp, renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
